<template>
  <div>
    <navigation-sub
      :list="[
        {
          title: $t('ceoAndRiders.ceo.name')
        },
        {
          title: $t('ceoAndRiders.mart.name')
        },
        {
          title: $t('ceoAndRiders.connect.name')
        }
      ]"
    />

    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.vendorsRiders') }}</h4>
    </section>

    <section class="service-list">
      <!-- 배민외식업광장 -->
      <article :id="hashTitle($t('ceoAndRiders.ceo.name'))" class="article-anchor">
        <div class="service-box" data-service="ceo" :data-id="$t('ceoAndRiders.ceo.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/ceo.jpg" :alt="$t('ceoAndRiders.ceo.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_ceo.png" :alt="$t('ceoAndRiders.ceo.name')">
            <html-view tag="p" :value="$t('ceoAndRiders.ceo.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('ceoAndRiders.ceo.content')" />
            <div class="btn-wrap">
              <a
                href="https://ceo.baemin.com/"
                class="btn-link"
                target="_blank"
                @click="setGtag({
                  name: '서비스_페이지 링크',
                  category: '사장님/라이더',
                  label: '서비스링크_외식업광장',
                  page: '서비스'})"
              >{{ $t('ceoAndRiders.ceo.site') }}<icon-blank /></a>
            </div>
          </div>
        </div>
      </article>

      <!-- 배민상회 -->
      <article :id="hashTitle($t('ceoAndRiders.mart.name'))" class="article-anchor">
        <div class="service-box" data-service="mart" :data-id="$t('ceoAndRiders.mart.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/mart.jpg" :alt="$t('ceoAndRiders.mart.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_mart.png" :alt="$t('ceoAndRiders.mart.name')">
            <html-view tag="p" :value="$t('ceoAndRiders.mart.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('ceoAndRiders.mart.content')" />
            <div class="btn-wrap">
              <a
                href="https://mart.baemin.com/"
                class="btn-link"
                target="_blank"
                @click="setGtag({
                  name: '서비스_페이지 링크',
                  category: '사장님/라이더',
                  label: '서비스링크_배민상회',
                  page: '서비스'})"
              >{{ $t('ceoAndRiders.mart.site') }}<icon-blank /></a>
            </div>
          </div>
        </div>
      </article>

      <!-- 배민커넥트 -->
      <article :id="hashTitle($t('ceoAndRiders.connect.name'))" class="article-anchor">
        <div class="service-box" data-service="connect" :data-id="$t('ceoAndRiders.connect.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/connect.jpg" :alt="$t('ceoAndRiders.connect.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_connect.png" :alt="$t('ceoAndRiders.connect.name')">
            <html-view tag="p" :value="$t('ceoAndRiders.connect.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('ceoAndRiders.connect.content')" />
            <div class="btn-wrap">
              <a
                href="https://join.baeminconnect.com/"
                class="btn-link"
                target="_blank"
                @click="setGtag({
                  name: '서비스_페이지 링크',
                  category: '사장님/라이더',
                  label: '서비스링크_커넥트',
                  page: '서비스'})"
              >{{ $t('ceoAndRiders.connect.site') }}<icon-blank /></a>
            </div>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import gtag from '@/mixins/gtag'
import { hashTitle } from '@/util'

export default {
  components: {
    navigationSub: () => import('@/components/base/NavigationSub'),
    iconBlank: () => import('@/static/svg/blank.svg'),
  },
  mixins: [gtag],
  methods: { hashTitle }
}
</script>
